module.exports = __webpack_public_path__ + "static/media/TradeGothicLTStd-BoldExt.50717d0b.otf";